/** The noun to use after count: pluralize(1, 'user') is 'user', pluralize(2, 'user') is 'users'. */
export function pluralize(count: number, singular: string, plural = `${singular}s`): string {
  return count === 1 ? singular : plural;
}
